import { cn } from '@/lib/utils';
import {
  Stepper,
  StepperIndicator,
  StepperItem,
  StepperTrigger,
} from '@/components/ui/stepper';

const TrialStepper = ({ currentStep = 1, title }) => {
  const steps = [1, 2];

  return (
    <div className='space-y-1'>
      <h1 className='text-xl font-semibold'>{title}</h1>
      <div className='space-y-1'>
        <Stepper value={currentStep} className='w-full'>
          {steps.map((step) => (
            <StepperItem key={step} step={step} className='flex-1'>
              <StepperTrigger
                className='w-full flex-col items-start gap-2'
                asChild
              >
                <StepperIndicator
                  asChild
                  className={cn(
                    'h-2 w-full rounded-none',
                    step <= currentStep ? 'bg-primary' : 'bg-border'
                  )}
                >
                  <span className='sr-only'>{step}</span>
                </StepperIndicator>
              </StepperTrigger>
            </StepperItem>
          ))}
        </Stepper>
        <div className='text-end text-sm font-medium tabular-nums text-muted-foreground'>
          Step {currentStep} of {steps.length}
        </div>
      </div>
    </div>
  );
};

export default TrialStepper;
